(function ($) {
  if ($(".page-template").hasClass("page-template-checkout")) {
    sessionStorage.removeItem("fmp_user");
    
    let forceFocusFn = function () {
      var searchInput = document.querySelector(
        ".select2-container--open .select2-search__field"
      );
      // If exists
      if (searchInput) searchInput.focus();
    };

    $(document).on("select2:open", () => {
      setTimeout(() => forceFocusFn(), 10);
    });

    $(':input:visible, .fmp-button-submit').each(function (i) {
      $(this).attr('tabindex', i + 1);
    });

    let input = $(".woocommerce-billing-fields .input-text");

    $(input)
    .on("blur", function () {
      $(this).closest(".form-row").removeClass("focused");

      tmpVal = $(this).val();

      if (tmpVal !== "") {
        $(this).closest(".form-row").addClass("has-value");
      } else {
        $(this).closest(".form-row").removeClass("has-value");
      }
    })
    .on("focus", function () {
      $(this).closest(".form-row").addClass("focused");
    })
    .on("click", function () {
      return false;
    });

    // Checkout page update quantity
    $(".page-template-checkout").on(
      "click",
      "input[name=fmp-product-quantity]",
      function () {
        $(this).val("");
      }
    );

    $(".page-template-checkout").on(
      "click keyup",
      "input[name=fmp-product-quantity]",
      function () {
        var input = parseInt($(this).val());
        var inputMax = parseInt($(this).attr("max"));
        var productId = $(this).closest(".fmp-resume-item").attr("data-id");
        var quantity = $(this).closest(".fmp-resume-item").attr("data-quantity");

        if (input == 0) {
          alert("The minimum quantity is 1 of this service.");
          $(this).closest(".fmp-resume-item").attr("data-quantity", 1);
          $(this).val(1);
          fmpChangeQuantity(productId, 1, $(this));
        }

        if (!inputMax || input > inputMax) {
          alert("The maximum quantity is " + inputMax + " of this service.");
          $(this).val(quantity);
          fmpChangeQuantity(productId, quantity, $(this));
        }
        if (input > 0 && input <= inputMax) {
          $(this).closest(".fmp-resume-item").attr("data-quantity", input);
          fmpChangeQuantity(productId, input, $(this));
        }
      }
    );

    $(".page-template-checkout").on(
      "focusout",
      "input[name=fmp-product-quantity]",
      function () {
        var input = parseInt($(this).val());
        if (isNaN(input)) {
          var quantity = $(this)
            .closest(".fmp-resume-item")
            .attr("data-quantity");
          $(this).val(quantity);
          fmpChangeQuantity();
        }
      }
    );

    function fmpChangeQuantity(productId, input, selectProduct) {
      var addedProduct = [];
      var totalQuantity = 0;
      $(".fmp-resume-item").each(function () {
        var value = $(this).attr("data-id");
        var quantity = $(this).attr("data-quantity");
        var data = {
          id: value,
          quantity: quantity,
        };
        totalQuantity += parseInt(quantity);
        addedProduct.push(data);
      });

      if($(".fmp-mini-cart-total")){
        $(".fmp-cart-count .fmp-mini-cart-total").text( totalQuantity );
      }

      addedProduct = addedProduct.filter(function (el) {
        if (el.quantity == 0) {
          return productId.indexOf(el.id) < 0;
        } else {
          return productId;
        }
      });
      fmpUpdateCheckoutCart(productId, addedProduct, selectProduct);
    }

    // Checkout page product remove
    $(".page-template-checkout").on("click", ".fmp-remove", function () {
      var removeId = $(this).closest(".fmp-resume-item").attr("data-id");
      var quantity = $(this).closest(".fmp-resume-item").attr("data-quantity");
      if($(".fmp-mini-cart-total")){
        $(".fmp-cart-count .fmp-mini-cart-total").text( $(".fmp-cart-count .fmp-mini-cart-total").text() - quantity );
      }
      $(this).closest(".fmp-resume-item").attr("data-quantity", 0);
      var addedProduct = [];
      $(".fmp-resume-item").each(function () {
        var value = $(this).attr("data-id");
        var quantity = $(this).attr("data-quantity");
        var data = {
          id: value,
          quantity: quantity,
        };
        addedProduct.push(data);
      });
      addedProduct = addedProduct.filter(function (el) {
        return removeId.indexOf(el.id) < 0;
      });

      var selectProduct = $(this);
      fmpUpdateCheckoutCart(removeId, addedProduct, selectProduct);
    });

    function fmpUpdateCheckoutCart(productId, addedProduct, selectProduct) {
      var productQuantity = $(".fmp_ca_resume")
        .find('[data-id="' + productId + '"]')
        .attr("data-quantity");
      var parentResume = $("input[name=fmp_parent_resume]").val(); 
      var data = {
        action: "fmp_add_remove_cart",
        nounce: localized.ajaxnonce,
        remove_id: productId,
        quantity: productQuantity,
        added_product: addedProduct,
        parent_resume: parentResume,
      };
      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          if (productQuantity == 0) {
            $(".fmp_ca_resume").find('[data-id="' + productId + '"]').remove();
          }
          addedProduct = addedProduct.filter(function (el) {
            return el.id;
          });

          if( null != response.total_before ){
            $(".fmp-total-before").html( response.total_before );
            $(".fmp-total-saved b").html( response.total_saved );
          }else{
            $(".fmp-total-before").remove();
            $(".fmp-saved").remove();
          }

          $(".fmp-cart-total").html(response.total);
          $(".fmp-afterpay .fmp-cart-total").html(response.afterpay);
          if (addedProduct.length == 0) {
            window.location.href = window.location.origin;
          }

          var detail = response.data;

          if (detail) {
            detail.forEach(function (e) {
              var discount = '';
              if( null != e.before_discount ){
                discount = e.before_discount;
              }
              $('li[data-id="' + e.product_id + '"]')
                .find(".fmp-cart-block__item__price")
                .html(discount + response.currentSymbol + e.price);
            });
          }

          if (response.hideUserForm == true) {
            $(".woocommerce-form-user-toggle, .fmp-user-form").hide().fadeOut();
            $("#billing_email_field, #billing_phone_field").show();
            $(".woocommerce-checkout").removeClass("fmp-enable-user");
          }
        },
      });
    }
    
    $(window).on('load',function(){
      setTimeout(function(){
      $('#place_order').prop("disabled",true);
      },8000);
      
      if ($(".fmp-afterpay").hasClass("fmp-hidden")) {
        $(".woocommerce-checkout-payment .payment_method_afterpay").hide();
      }

      var userDetail = JSON.parse(sessionStorage.getItem("fmp_user_detail"));
      if (userDetail) {
        if(userDetail.token && userDetail.full_name){
          $(".fmp-user-form, .woocommerce-form-user-toggle").remove();
          $("#fmp_login_token").val(userDetail.token);
          $("#fmp_full_name").val(userDetail.full_name);
          $(".woocommerce-checkout").removeClass("fmp-enable-user");
        }

        if(userDetail.email){
          $("#billing_email").val(userDetail.email);
          $("#billing_email_field").hide();
        }else{
          $("#billing_email_field").show();
        }

        if(userDetail.phone_number){
          $("#billing_phone").val(userDetail.phone_number);
          $("#billing_phone_field").hide();
        }else{
          $("#billing_phone_field").show();
        }
      }

    });
  
    $(".fmp-user").click(function (e) {
      e.preventDefault();
      $(".woocommerce-form-user-toggle").toggleClass("sign-in");
      $("#fmp_password").toggleClass("sign-in-password");
      $("#fmp_password").val("");
      $("#fmp_password").parent().removeClass("error valid-pswd");
      $("#fmp_password").parent().find("label span").text("Password*");

      $("#fmp_confirm_password").val("");
      $("#pswd_info").hide();
      $(this)
        .text($(this).text() == "Sign In" ? "Sign Up" : "Sign In")
        .fadeIn();
      $(".userform-heading")
        .text(
          $(".userform-heading").text() == "New Client? Sign Up!" ? "Already a Client? Sign In!" : "New Client? Sign Up!"
        )
        .fadeIn();
      $(".woocommerce-form-user-toggle span")
        .text(
          $(".woocommerce-form-user-toggle span").text() == "Not a Client Yet?"
            ? "Already a Client?"
            : "Not a Client Yet?"
        )
        .fadeIn();

      $(".fmp_password_field, .fmp_name_field, .fmp_phone_field").toggleClass("fmp-hidden");
    });

    //Toggle Password
    $(".password_toggle").each(function (i, element) {
      $(element).click(function () {
        const inpType =
          $(element).prevAll("input").attr("type") === "password"
            ? "text"
            : "password";
        $(element).prevAll("input").prop("type", inpType);
        $(element).toggleClass("active");
      });
    });

    $(".page-template-checkout").on(
      "keyup focusout",
      "#fmp_password",
      function (e) {
        var pswd = $(this).val();
        if (this.value === "") {
          $(this).parent().addClass("error");
        } else {
          $(this).parent().find("label span").text("Password*");
          $(this).parent().removeClass("error");
        }
        if (!$(this).hasClass("sign-in-password")) {
          var pswdValidation = passwordValidation( pswd );
          if ( false === pswdValidation) {
            $(this).parent().addClass("error");
            if( $(this).parent().hasClass("valid-pswd") ){
              $(this).parent().removeClass("valid-pswd");
              $(this).parent().addClass("invalid-pswd");
            }

            if( "focusout" === e.type ){
              $(this).parent().addClass("invalid-pswd");
            }

            if (pswd.length < 1) {
              $(this).parent().find("label span").text("Password*");
              $("#pswd_info").hide();
            } else {
              $("#pswd_info").show();
              if( "focusout" === e.type ){
                $(this).parent().find("label span").text("Invalid Password*");
                $("#pswd_info").hide();
              }
            }
          } else {
            $(this).parent().addClass("valid-pswd");
            $(this).parent().removeClass("error invalid-pswd");
            $(this).parent().find("label span").text("Password*");
            $("#pswd_info").hide();
          }
        }
      }
    );

    $(".page-template-checkout").on(
      "keyup focusout",
      "#fmp_confirm_password",
      function (e) {
        if (this.value === "") {
          $(this).parent().addClass("error");
          $(this).parent().find("label span").text("Confirm Password*");
        } else {
          $(this).parent().removeClass("error");
        }
        var password = $("input[name=fmp_password]");
        var confirmPassword = $("input[name=fmp_confirm_password]");
        if( "focusout" === e.type && "" !== confirmPassword.val() ){
          fmpConfirmInputField(password, confirmPassword, "Password");
        }
        if( "keyup" === e.type ){
          $(confirmPassword)
          .parent()
          .find("label span")
          .text("Confirm Password*");
        }
      }
    );

    function fmpConfirmInputField(data, confirmData, type) {
      if (data.val() != confirmData.val()) {
        $(confirmData).parent().addClass("error");
        $(confirmData)
          .parent()
          .find("label span")
          .text("Wrong " + type + "*");
      } else {
        $(confirmData).parent().removeClass("error");
        $(confirmData)
          .parent()
          .find("label span")
          .text("Confirm " + type + "*");
      }
    }

    $("#fmp_email").focusout(function (e) {
      var validationEmail = fmpEmailValidation($(this).val());
      if (validationEmail === false) {
        $(this).parent().addClass("error");
        if($(this).val().length >= 1){
          $(this).parent().find("label span").text("Invalid Email address*");
        }else{
          $(this).parent().find("label span").text("Email address*");
        }
      } else {
        $(this).parent().removeClass("error");
        $(this).parent().find("label span").text("Email address*");
        $("#billing_email").val($(this).val());
      }
    });

    $("#fmp_first_name, #fmp_last_name").focusout(function (e) {
      if( "" == $(this).val() ) {
        $(this).parent().addClass("error");
      } else {
        $(this).parent().removeClass("error");
      }
    });

    if ($(".woocommerce-checkout").hasClass("fmp-enable-user")) {
      $("#billing_email_field, #billing_phone_field").hide();
    }

    $("input").focusout(function (e) {
      fmpValueEmpty(this);
    });

    $("#billing_country").on("select2:close", function (e) {
      fmpValueEmpty(this);
    });

    if ($("#billing_state")) {
      $("#billing_state").on("select2:close", function (e) {
        fmpValueEmpty(this);
      });
    }

    function fmpValueEmpty(selector) {
      if (selector.value === "") {
        $(selector).closest("p").addClass("error");
      } else {
        $(selector).closest("p").removeClass("error");
      }
    }

    $("#billing_email").focus(function (e) {
      $(this).closest("p").find("label").text("Email address*");
      $(this).closest("p").removeClass("error");
    });

    $("#billing_email").focusout(function (e) {
      var validationEmail = fmpEmailValidation($('#billing_email').val());
      if (validationEmail === false) {
        $('#billing_email').closest("p").addClass("error");
        if($('#billing_email').val().length >= 1){
          $('#billing_email').closest("p").find("label").text("Invalid Email address*");
        }else{
          $('#billing_email').closest("p").find("label").text("Email address*");
        }
      } else {
        $('#billing_email').closest("p").find("label").text("Email address*");
        $('#billing_email').closest("p").removeClass("error");
      }
    });

    $(".page-template-checkout").on("keyup focusout","#billing_phone", function (e) {
      var phoneNumber = $("#billing_phone").val();
      phoneNumber = phoneNumber.replace(/[^A-Z0-9]/ig,'');
      var regex = /^\d+$/;
      if( !regex.test(phoneNumber) && "focusout" === e.type ){
        $('#billing_phone').closest("p").addClass("error");
        if($('#billing_phone').val().length >= 1){
          $('#billing_phone').closest("p").find("label").text("Invalid Phone*");
        }else{
          $('#billing_phone').closest("p").find("label").text("Phone*");
        }
      }else{
        $('#billing_phone').closest("p").find("label").text("Phone*");
        $('#billing_phone').closest("p").removeClass("error");
      }
    });

    $(".page-template-checkout").on("keyup focusout","#fmp_phone", function (e) {
      var phoneNumber = $("#fmp_phone").val();
      phoneNumber = phoneNumber.replace(/[^A-Z0-9]/ig,'');
      var regex = /^\d+$/;
      if( !regex.test(phoneNumber) && "focusout" === e.type ){
        $('#fmp_phone').closest(".fmp_phone_field").addClass("error");
        if($('#fmp_phone').val().length >= 1){
          $('#fmp_phone').closest(".fmp_phone_field").find("span").text("Invalid Phone*");
        }else{
          $('#fmp_phone').closest(".fmp_phone_field").find("span").text("Phone*");
        }
      }else{
        $('#fmp_phone').closest(".fmp_phone_field").find("span").text("Phone*");
        $('#fmp_phone').closest(".fmp_phone_field").removeClass("error");
        $('#billing_phone').val( $("#fmp_phone").val() );
      }
    });

    $('form.woocommerce-checkout input, .fmp-button-submit').on("keypress", function(event){
      if( "Enter" === event.key && true === $("#place_order").prop("disabled") ) {
        setTimeout(function(){
          $(".fmp-button-submit").click();
        },2000);
      }
    });

    $(".fmp-create-account").on("click", ".fmp-button-submit", function (e) {
      e.preventDefault();
      $(".fmp-button-submit span").text('Loading...');
      $(this).attr('disabled', true);
      sessionStorage.removeItem("__user");

      $(
        "#billing_first_name, #billing_last_name, #billing_email, #billing_phone, #billing_address_1, #billing_city, #billing_postcode, #billing_country"
      ).each(function () {
        if (this.value === "") {
          $(this).closest("p").addClass("error");
        } else {
          $(this).closest("p").removeClass("error");
        }
      });

      var inputValueEmail = false;
      var inputValuePassword = false;
      var inputValuePhoneNumber = false;

      var phoneNumber = $("#billing_phone").val();
      if( !phoneNumber ){
        phoneNumber = $("#fmp_phone").val();
      }
      if (phoneNumber) {
        phoneNumber = phoneNumber.replace(/[^A-Z0-9]/ig,'');
      }
      var regex = /^\d+$/;
      if( !regex.test(phoneNumber) ){
        $('#billing_phone').closest("p").addClass("error");
        $('#fmp_phone').closest(".fmp_phone_field").addClass("error");
        $('#billing_phone').closest("p").find("label").text("Invalid Phone*");
        $('#fmp_phone').closest(".fmp_phone_field").find("span").text("Invalid Phone*");
      }else{
        $('#billing_phone').closest("p").find("label").text("Phone*");
        $('#fmp_phone').closest(".fmp_phone_field").find("span").text("Phone*");
        inputValuePhoneNumber = true;
      }

      if( $(".woocommerce-form-user-toggle").hasClass("sign-in") ){
        inputValuePhoneNumber = true;
      }

      if ($("#fmp_confirm_password, #fmp_first_name, #fmp_last_name").val() == "") {
        $("#fmp_confirm_password, #fmp_first_name, #fmp_last_name").parent().addClass("error");
      }

      var validationLoginEmail = fmpEmailValidation($("#fmp_email").val());
      if (validationLoginEmail === false) {
        $("#fmp_email").parent().addClass("error");
        $("#fmp_email")
        .parent()
        .find("label span")
        .text("Invalid Email address*");
      } else {
        $("#fmp_email").parent().removeClass("error");
        $("#fmp_email").parent().find("label span").text("Email address*");
        $("#billing_email").val($("#fmp_email").val());
        inputValueEmail = true;
      }

      var validationBillingEmail = fmpEmailValidation(
        $("#billing_email").val()
      );
      if (validationBillingEmail === false) {
        $("#billing_email").closest("p").addClass("error");
        if($("#billing_email").val().length >= 1){
          $("#billing_email")
          .closest("p")
          .find("label")
          .text("Invalid Email address*");
        }else{
          $("#billing_email").closest("p").find("label").text("Email address*");
        }
      } else {
        $("#billing_email").closest("p").find("label").text("Email address*");
        $("#billing_email").closest("p").removeClass("error");
      }

      var pswd = $("#fmp_password").val();
      if (!$("#fmp_password").hasClass("sign-in-password")) {
        var pswdValidation = passwordValidation( pswd );
        if (pswdValidation) {
          $("#fmp_password").parent().removeClass("error");
          $("#pswd_info").hide();

          var pwd = $("#fmp_password");
          var confirmpwd = $("#fmp_confirm_password");
          if (pwd.val() == confirmpwd.val()) {
            inputValuePassword = true;
          }
        } else {
          $("#fmp_password").parent().addClass("error");
        }
      } else {
        if ($("#fmp_password").val() == "") {
          $("#fmp_password").parent().addClass("error");
        } else {
          $("#fmp_password").parent().removeClass("error");
          inputValuePassword = true;
        }
      }

      var formData = $("form").serializeArray();
      var dataObj = {};
      var total = $(".fmp-cart-total bdi")
        .text()
        .replace(/[^0-9\.]+/g, "");

      if( 0 == total ){
        total = 1;
      }

      $(formData).each(function (i, field) {
        dataObj[field.name] = field.value;
      });
      var inputFieldsEmpty = true;
      if ("#billing_state") {
        if ($("#billing_state").val() === "") {
          $("#billing_state").closest("p").addClass("error");
          inputFieldsEmpty = true;
        } else {
          $("#billing_state").closest("p").removeClass("error");
          inputFieldsEmpty = false;
        }
      }

      if (
        !dataObj.billing_email ||
        // !dataObj.billing_phone ||
        !dataObj.billing_address_1 ||
        !dataObj.billing_city
      ) {
        $('.fmp-button-submit span').text('Proceed to Checkout');
        $('.fmp-button-submit').attr('disabled', false);
        $("html, body").animate(
          {
            scrollTop: $(".error").offset().top,
          },
          300
        );
        inputFieldsEmpty = true;
      } else {
        inputFieldsEmpty = false;
      }

      if (
        !$(".woocommerce-checkout").hasClass("fmp-enable-user") &&
        inputValuePhoneNumber == true &&
        inputFieldsEmpty == false &&
        validationBillingEmail
      ) {
        $(".fmp-button-submit").hide("slow");
        $('#place_order').prop("disabled", false);

        $("#order_review_heading, #order_review").show("slow");
        $("html, body").animate(
          {
            scrollTop: $("#order_review_heading").offset().top - 100,
          },
          300
        );
      }

      if (
        $(".woocommerce-checkout").hasClass("fmp-enable-user") &&
        inputValuePhoneNumber === true &&
        inputValueEmail === true &&
        inputValuePassword === true &&
        inputFieldsEmpty === false
      ) {

        userDetail = {
          email: dataObj.billing_email,
          password: dataObj.fmp_password,
          firstname: dataObj.fmp_first_name,
          lastname: dataObj.fmp_last_name
        }

        formType = "sign-up";
        if( $(".woocommerce-form-user-toggle").hasClass("sign-in") ){
          formType = "sign-in";
        }

        var data = {
          action: "fmp_create_account",
          nounce: localized.ajaxnonce,
          form_type: formType,
          user: userDetail
        };

        $.ajax({
          type: "POST",
          dataType: "json",
          url: localized.ajaxurl,
          data: data,
          success: function success(response) {
            if( true === response.status ){
              $(".user-error").text("");
              if(response.phone_number){
                $("#billing_phone").val(response.phone_number);
              }else{
                if( $("#fmp_phone").val() ){
                  $('#billing_phone').val( $("#fmp_phone").val() );
                } else {
                  $( '#billing_phone_field' ).show();
                }
              }
              $("#fmp_full_name").val(response.full_name);
              $(".fmp-button-submit").hide("slow");
              $('#place_order').prop("disabled", false);
              $("#order_review_heading, #order_review").show("slow");
              $("#fmp_phone, #fmp_email, #fmp_password, #fmp_confirm_password").attr("readonly", true);
              $(".fmp-user, .password_toggle").css("pointer-events", "none");
              $("html, body").animate(
                {
                  scrollTop: $("#order_review_heading").offset().top - 100,
                },
                300
              );

              if( response.token ){
                $("#fmp_login_token").val(response.token);
              }

              if( "sign-in" == formType ){
                $("#fmp_first_name, #fmp_last_name").val("");
              }else {
                $("#fmp_full_name").val( dataObj.fmp_first_name + ' ' + dataObj.fmp_last_name );
              }

            }else{
              $('.fmp-button-submit span').text('Proceed to Checkout');
              $('.fmp-button-submit').attr('disabled', false);
              $(".user-error").text(response.message);
              $("html, body").animate(
                {
                  scrollTop: $(".user-error").offset().top - 50,
                },
                300
              );
            }
          }
        });

      }else {
        $('.fmp-button-submit span').text('Proceed to Checkout');
        $('.fmp-button-submit').attr('disabled', false);
      }
    });

    function fmpEmailValidation(email) {
      var regex =
        /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (regex.test(email)) {
        return true;
      } else {
        return false;
      }
    }

    function passwordValidation(pswd){
      var lowerCasePattern = /^(?=.*[a-z]).+$/;
      var upperCasePattern = /^(?=.*[A-Z]).+$/;
      var numberPattern = /^(?=.*[\d]).+$/;
      var specialCharacterPatter = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;
      var characterCountPattern = /^.{8,}/;

      checkPassword( pswd, lowerCasePattern, ".lowercase-char" );
      checkPassword( pswd, upperCasePattern, ".uppercase-char" );
      checkPassword( pswd, numberPattern, ".number-char" );
      checkPassword( pswd, specialCharacterPatter, ".special-char" );
      checkPassword( pswd, characterCountPattern, ".8-char" );

      if( lowerCasePattern.test(pswd) && upperCasePattern.test(pswd) && numberPattern.test(pswd) && specialCharacterPatter.test(pswd) && characterCountPattern.test(pswd) ){
        return true;  
      }else{
        return false;
      }
    }

    function checkPassword(pswd, regex, element){
      if( regex.test(pswd) ){
        $(element).addClass("completed");
        $(element).removeClass("not-completed");
      }else{
        $(element).removeClass("completed");
        $(element).addClass("not-completed");
      }
    }

  }
})(jQuery);
